import { useModal } from './useModal';
import { localStore } from '~/modules/common/utils/localStorageUtils';
import { useAuth } from '~/modules/auth/state/useAuth';

export function useMailVerify() {
  const { openModal } = useModal();
  const { user, isLoggedIn } = useAuth();
  /**
   * Show Modal
   */
  const showVerifyModal = () => {
    openModal(import('~/modules/common/components/modals/ModalEmailVerify' /* webpackChunkName: "ModalEmailVerify" */));
  };

  return {
    setMailVerify: () => {
      localStore.setItem('o-mail-verified', true, { expireMs: 60 });
    },
    getMailVerify: () => {
      return localStore.getItem('o-mail-verified') || !(isLoggedIn.value && !user.value?.emailVerified);
    },
    showVerifyModal,
  };
}
